import lessRequire from '../../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import cn from  'classname';

import some from 'lodash/some';
import isNull from 'lodash/isNull';
import _find from 'lodash/find';

import { formatMoney } from '../../../shared/format';
import { getCurrencyIcon } from '../../../../../shared/js/get-currency-icon';
import { wasBoostedLocation } from '../../../offers/shared';
import createConfirm from  '../../../shared/confirm';

import { connect } from 'react-redux';

const initialRowsLength = 7;

const getBoostExtraValue = ({ differenceBetweenBaseAndIndividual, amount, boost_till, boost_value }) => {
	if (differenceBetweenBaseAndIndividual) return differenceBetweenBaseAndIndividual;
	if (!isNull(boost_till)) return amount - Math.round(amount / (1 + Number(boost_value)));
};

lessRequire('modules/streams/components/stream-form/offer-geo-stats.less');

const isEverad = process.env.CPA_ENV === 'everad';

class SingleOfferGeo extends  React.Component {
	constructor(props) {
		super(props);
		this.state = {
			trHover: false,
			currentIndex: null
		};
	}

	tdOnMouseEnter(index) {
		//turn on in case of boost tooltip
		// this.setState({currentIndex: index});
		// this.setState({trHover: true});
	}

	tdOnMouseLeave() {
		//turn on in case of boost tooltip
		// this.setState({currentIndex: null});
		// this.setState({trHover: false});
	}

	render() {
		const {
			offerGeoStats,
			toggleGeoStats,
			userBoostInfo,
			selectedOffer,
			intl
		} = this.props;

		const  shouldShowBoosterTh = some(offerGeoStats.rows, item => {
			return item.offerAvailable &&
				!wasBoostedLocation(userBoostInfo, selectedOffer.id, item.locationId) &&
				item.boost_till == null &&
				!item.is_individual_term &&
				item.isBoosterAvailable;
		});

		return (
			<table className="offer-geo">
				<thead className="offer-geo__head">
					<tr>
						<th><span>{intl('Страна')}</span></th>
						<th width={1} className="booster-th" style={this.props.is_master ? {display:'none'}:{}}>
							<span>{shouldShowBoosterTh ? 'Boost' : ''}</span>
						</th>
						<th className="right"><span>{intl('Выпл.')}</span></th>
						{ !isEverad && <th className="right"><span>{intl('Аппрув')}</span></th>}
					</tr>
				</thead>
				<tbody className="offer-geo__body">
					{this.getGeoRows()}
					{offerGeoStats.totalRows > initialRowsLength && (
						showAll(
							offerGeoStats.shouldShowAll,
							offerGeoStats.totalRows,
							toggleGeoStats,
							intl
						)
					)}
				</tbody>
			</table>
		);
	}

	getGeoRows() {
		const result = [];
		const data = this.props.offerGeoStats || [];
		const intl = this.props.intl;
		const selectedOffer = this.props.selectedOffer;
		const campaignPayouts = selectedOffer.campaign_payouts || [];
		data.rows.map((item, i) => {
			const campaignPayout = _find(campaignPayouts, {country_id: item.locationId, currency: item.currency });
			if (!data.shouldShowAll && i > initialRowsLength - 1) {
				return;
			}
			result.push(
				<tr key={i} className={cn(
					'geo-row',
					this.state.trHover && this.state.currentIndex == i ? 'boost-hover' : ''
				)}>
					<td className="country">
						<span className="country-wrapper">
							<span
								className={`flag-icon flag-icon-${item.country_code.toLowerCase()}`}
							/>
							<span className="country-title">{item.country_name}</span>
						</span>
					</td>
					{
						item.offerAvailable &&
					item.boost_till == null &&
					!wasBoostedLocation(
						this.props.userBoostInfo,
						this.props.selectedOffer.id,
						item.locationId
					) &&
					!item.is_individual_term &&
					item.isBoosterAvailable ?
							<td
								onMouseEnter={() => this.tdOnMouseEnter(i)}
								onMouseLeave={() => this.tdOnMouseLeave()}
								className="booster"
								style={this.props.is_master ? {display:'none'}:{}}
								onClick={e => {
									e.preventDefault();
									this.setState({trHover: false});
									createConfirm({
										title: intl('Активировать boost%s', '?'),
										body: intl(
											'Вы подтверждаете включение опции Boost для оффера %s по гео %s',
											`<strong>${this.props.selectedOffer.title}</strong>`,
											`<strong>${item.country_name}</strong>`,
										),
										buttonSuccessText: intl('Подтвердить'),
										buttonCancelText: intl('Отмена')
									}).then(isConfirmed => {
										isConfirmed && this.props.boost(item.locationId);
									});
								}}>
								{/*//turn on in case of boost tooltip*/}
								{/*<span className="booster-text">BOOST</span>*/}
								<span className="booster-btn" />
								<span className="booster-value">+{Math.round(item.boost_value * 10000) / 100}%</span>
							</td> :
							<td style={this.props.is_master ? {display:'none'}:{}}></td>
					}
					<td width={1} className={cn(
						'payout right',
						(item.isDifferentFromBasePayout || !isNull(item.boost_till)) && 'different-from-base'
					)}>
						<span className="money">
							{formatMoney(
								campaignPayout ? campaignPayout.amount : item.amount, true
							)} <span className="currency">{getCurrencyIcon(item.currency)}</span>
						</span>
						{ (item.isDifferentFromBasePayout || !isNull(item.boost_till)) && (
							<span className={cn('difference-amount', !isNull(item.boost_till) && 'boosted')}>
								<span className="text-grey">{intl('Спец. условия')}</span>{' '}
								<span className="text-black">
									{getBoostExtraValue(item) > 0 ? '+' : '-'}{' '}
									{Math.abs(getBoostExtraValue(item))}{' '}{getCurrencyIcon(item.currency)}</span></span>
						) }
					</td>
					{
						!isEverad &&
						<td width={1} className="payout right">
							{item.approve
								? <span className="money">{formatMoney(item.approve, true)} %</span>
								: intl('NEW!')}
						</td>
					}
				</tr>
			);
		});
		return result;
	}
}

const showAll = (shouldShowAll, total, toggleGeoStats, intl) => {
	const className = shouldShowAll ? 'hide' : 'show';
	const total10 = total % 10;
	let geosWord = '';
	switch (total10) {
		case 1: geosWord = 'страну'; break;
		case 2:
		case 3:
		case 4: geosWord = 'страны'; break;
		default: geosWord = 'стран'; break;
	}
	return (
		<tr>
			<td colSpan={4} className="show-all-geo-stats-td">
				<div>
					<a href="#" className={className} onClick={e => {
						e.preventDefault();
						toggleGeoStats();
					}}>
						{!shouldShowAll
							? `${intl('Все')} ${total} ${intl(geosWord)}`
							: `${intl('Скрыть')}`
						}
					</a>
				</div>
			</td>
		</tr>
	);
};

SingleOfferGeo.propTypes = {
	offerGeoStats: PropTypes.object,
	shedullesCallCenter: PropTypes.array,
	selectedOffer: PropTypes.object,
	userBoostInfo: PropTypes.array,
	toggleGeoStats: PropTypes.func,
	boost: PropTypes.func,
	intl: PropTypes.func,
	is_master: PropTypes.bool
};

const mapStateToProps = state => {
	let shedullesCallCenter = state.app &&
		state.app.lists['call-center-schedule'];
	return {
		is_master: state.app.userData.general.is_master,
		shedullesCallCenter: shedullesCallCenter.map(i => i.id)
	};
};

export default connect(mapStateToProps)(SingleOfferGeo);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/components/stream-form/offer-geo-stats.js